import { CommonModule } from '@angular/common';
// Angular Imports
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FlyoutLoggedinUserComponent } from '../../flyout/flyout-loggedin-user/flyout-loggedin-user.component';
import { FlyoutLoggedinUserModule } from '../../flyout/flyout-loggedin-user/flyout-loggedin-user.module';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { SwitchingAccountModule } from '../switching-account/switching-account.module';
// This Module's Componentss
import { InterstitialScreenComponent } from './interstitial-screen.component';

@NgModule({
  imports: [CommonModule, FlyoutLoggedinUserModule, SwitchingAccountModule],
  declarations: [InterstitialScreenComponent],
  exports: [InterstitialScreenComponent],
  providers: [BsModalRef, BsModalService, ContentHeaderFooterService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class InterstitialScreenModule {}
